import EventBus from "./event-bus";
import {errorHandler} from "./utils";

const axios = require('axios');

export function getCategories() {
  return new Promise(function(resolve, reject) {
    console.log("getCategories " + localStorage.getItem("JSTOKEN"));
    axios.get(process.env.ROOT_API + 'merchant/categories', {
      headers:{
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error=>{
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error);
      });
  })
}

export function getProducts(vendorId) {
  return new Promise(function(resolve, reject) {
    console.log("getCategories " + localStorage.getItem("JSTOKEN"));
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'merchant/products?vendorId=' + vendorId, {
      headers:{
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error=>{
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error);
      });
  })
}

export function getCategoryItems(categoryId) {
  return new Promise(function(resolve, reject) {
    console.log("getCategory Items " + localStorage.getItem("JSTOKEN"));
    axios.get(process.env.ROOT_API + 'merchant/category/products?categoryId=' + categoryId, {
      headers:{
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error=>{
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error);
      });
  })
}



// WEBPACK FOOTER //
// ./src/api/product.js